import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Select from 'react-select';
import ToggleSwitch from '@trendmicro/react-toggle-switch';

import TextareaCounter from './../../FormComponents/TextareaCounter';
import utils from '../../../lib/utils';

const bookBefore = [
  {
    label: '10 minutes',
    value: 'PT10M',
  },
  {
    label: '30 minutes',
    value: 'PT30M',
  },
  {
    label: '1 hour',
    value: 'PT1H',
  },
  {
    label: '2 hours',
    value: 'PT2H',
  },
  {
    label: '3 hours',
    value: 'PT3H',
  },
  {
    label: '6 hours',
    value: 'PT6H',
  },
  {
    label: '24 hours',
    value: 'PT24H',
  },
  {
    label: '48 hours',
    value: 'PT48H',
  },
  {
    label: '72 hours',
    value: 'PT72H',
  },
];

const rescheduleDuration = [
  {
    label: '1 hour',
    value: 'PT1H',
  },
  {
    label: '2 hours',
    value: 'PT2H',
  },
  {
    label: '3 hours',
    value: 'PT3H',
  },
  {
    label: '4 hours',
    value: 'PT4H',
  },
  {
    label: '6 hours',
    value: 'PT6H',
  },
  {
    label: '8 hours',
    value: 'PT8H',
  },
  {
    label: '12 hours',
    value: 'PT12H',
  },
  {
    label: '24 hours',
    value: 'PT24H',
  },
  {
    label: '48 hours',
    value: 'PT48H',
  },
  {
    label: '72 hours',
    value: 'PT72H',
  },
  {
    label: '96 hours',
    value: 'PT96H',
  },
  {
    label: 'NONE',
    value: 'PT0S',
  },
];

const cancellationDuration = [
  {
    label: '1 hour',
    value: 'PT1H',
  },
  {
    label: '2 hours',
    value: 'PT2H',
  },
  {
    label: '3 hours',
    value: 'PT3H',
  },
  {
    label: '4 hours',
    value: 'PT4H',
  },
  {
    label: '6 hours',
    value: 'PT6H',
  },
  {
    label: '8 hours',
    value: 'PT8H',
  },
  {
    label: '12 hours',
    value: 'PT12H',
  },
  {
    label: '24 hours',
    value: 'PT24H',
  },
  {
    label: '48 hours',
    value: 'PT48H',
  },
  {
    label: '72 hours',
    value: 'PT72H',
  },
  {
    label: '96 hours',
    value: 'PT96H',
  },
  {
    label: 'NONE',
    value: 'PT0S',
  },
];

const customStyles = {
  menu: (provided, state) => ({
    ...provided,
    zIndex: 3,
  }),
};

export default function Bookings({
  details,
  errors,
  onChange,
  setRef,
  disabled,
  auth,
  softwares,
  preferences,
}) {
  const { schema } = preferences;
  const onBookBeforeChange = (item) => {
    onChange({
      target: {
        name: 'min_time_to_booking',
        value: item.value,
      },
    });
  };

  const onRescheduleAppointmentDurationChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'reschedule_appt_within_duration',
        checked: !details.reschedule_appt_within_duration,
      },
    });
    // onChange({
    //   target: {
    //     name: 'reschedule_appt_within_24hrs',
    //     value: item.value,
    //   },
    // });
  };

  const onRescheduleStateChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'disable_meevo_reschedule',
        checked: !details.disable_meevo_reschedule,
      },
    });
  };

  const onCancelAppointmentDurationChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'cancel_appt_within_duration',
        checked: !details.cancel_appt_within_duration,
      },
    });
  };

  const onOnlineRescheduleBooking = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'can_reschedule_booking_online',
        checked: !details.can_reschedule_booking_online,
      },
    });
  };

  const onOnlineCancelBooking = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'can_cancel_booking_online',
        checked: !details.can_cancel_booking_online,
      },
    });
  };

  const onSharePricingChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'can_share_pricing_with_clients',
        checked: !details.can_share_pricing_with_clients,
      },
    });
  };

  const onWalkInAppointmentsChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'appointments_walk_in',
        checked: !details.appointments_walk_in,
      },
    });
  };

  const isWalkInBasedOnAvailablity = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'is_walk_in_on_availability',
        checked: !details.is_walk_in_on_availability,
      },
    });
  };

  const onChangeAvgBookingValue = (event) => {
    onChange({
      target: {
        type: 'text',
        name: 'average_booking_value',
        value: event.target.value.replace(/[^\w\s]/gi, ''),
      },
    });
  };

  const onRescheduleDurationChange = (item) => {
    onChange({
      target: {
        name: 'reschedule_duration',
        value: item.value,
      },
    });
  };

  const onCancellationDurationChange = (item) => {
    onChange({
      target: {
        name: 'cancellation_duration',
        value: item.value,
      },
    });
  };

  const bzsW =
    auth.booking_software && auth.booking_software !== 'undefined'
      ? auth.booking_software
      : softwares.selectedSoftware;
  const { domain } = auth;
  return (
    <div className="bookings">
      {schema?.appointment_preferences?.properties.min_time_to_booking && (
        <div className="bookings__row">
          <p className="bookings__row__label">
            {schema?.appointment_preferences?.properties.min_time_to_booking
              ?.description ||
              `When TrueLark books appointments for you, how close to the start of
          the session can we book?`}
          </p>
          <div className="bookings__row__input">
            <Select
              value={bookBefore.filter(
                (option) => option.value === details.min_time_to_booking,
              )}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              options={bookBefore}
              styles={customStyles}
              onChange={onBookBeforeChange}
              disabled={disabled}
            />
          </div>
        </div>
      )}

      {bzsW === 'MEEVO' && (
        <div className="special-row">
          <p className="special-row__label">
            Can TrueLark reschedule appointments?
          </p>
          <div className="special-row__input">
            <ToggleSwitch
              checked={!details.disable_meevo_reschedule}
              name="disable_meevo_reschedule"
              onChange={onRescheduleStateChange}
              disabled={disabled}
            />
          </div>
        </div>
      )}

      {!details.disable_meevo_reschedule && (
        <>
          {schema?.appointment_preferences?.properties.reschedule_duration && (
            <div className="bookings__row">
              <p className="bookings__row__label">
                {schema?.appointment_preferences?.properties.reschedule_duration
                  ?.description || `Select the late reschedule window`}
              </p>
              <div className="bookings__row__input">
                <Select
                  value={rescheduleDuration.filter(
                    (option) => option.value === details.reschedule_duration,
                  )}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  options={rescheduleDuration}
                  styles={customStyles}
                  onChange={onRescheduleDurationChange}
                  disabled={disabled}
                />
              </div>
            </div>
          )}
          {schema?.appointment_preferences?.properties
            .reschedule_appt_within_duration && (
            <div className="special-row">
              <p className="special-row__label">
                {schema?.appointment_preferences?.properties
                  .reschedule_appt_within_duration?.description ||
                  `Can TrueLark reschedule appointments within your late reschedule window?`}
                {/* How close to the start of the appointment can TrueLark Reschedule appointments */}
              </p>
              <div className="special-row__input">
                <ToggleSwitch
                  checked={!!details.reschedule_appt_within_duration}
                  name="reschedule_appt_within_duration"
                  onChange={onRescheduleAppointmentDurationChange}
                  disabled={disabled}
                />
                {/* <Select
            value={bookBefore.filter((option) => option.value === details.reschedule_appt_within_24hrs)}
            getOptionLabel={option => option.label}
            getOptionValue={option => option.value}
            options={bookBefore}
            onChange={onRescheduleAppointment24Change}
            disabled={disabled}
          /> */}
              </div>
            </div>
          )}
          {schema?.appointment_preferences?.properties.reschedule_charges && (
            <div className="bookings__row">
              <p className="bookings__row__label">
                {schema?.appointment_preferences?.properties.reschedule_charges
                  ?.description || `What are your reschedule charges?`}
              </p>
              <div className="bookings__row__input">
                <input
                  type="text"
                  placeholder="e.g. 50%, $25"
                  name="reschedule_charges"
                  value={details.reschedule_charges}
                  onChange={onChange}
                  className={classnames({
                    'has-error': errors.reschedule_charges,
                  })}
                  ref={setRef}
                  disabled={disabled}
                />
                <span className="message--small message--error">
                  {errors.reschedule_charges &&
                    errors.reschedule_charges.message}
                </span>
              </div>
            </div>
          )}
        </>
      )}

      {schema?.appointment_preferences?.properties?.online_booking_link && (
        <div className="bookings__row">
          <p className="bookings__row__label">
            {schema?.appointment_preferences?.properties?.online_booking_link
              .description ||
              `Link where guests can book an appointment online`}
          </p>
          <div className="bookings__row__input">
            <input
              type="text"
              placeholder="URL"
              name="online_booking_link"
              value={details.online_booking_link}
              onChange={onChange}
              className={classnames({
                'has-error': errors.online_booking_link,
              })}
              ref={setRef}
              disabled={disabled}
            />
            <span className="message--small message--error">
              {errors.online_booking_link && errors.online_booking_link.message}
            </span>
          </div>
        </div>
      )}

      {schema?.appointment_preferences?.properties?.average_booking_value && (
        <div className="bookings__row">
          <p className="bookings__row__label">
            {schema?.appointment_preferences?.properties?.average_booking_value
              .description || `Average appointment booking value`}
          </p>
          <div className="bookings__row__input">
            <div className="currency">
              <span>$</span>
              <input
                type="text"
                placeholder="Average Booking Value"
                name="average_booking_value"
                value={details.average_booking_value}
                onChange={onChangeAvgBookingValue}
                className={classnames({
                  'has-error': errors.average_booking_value,
                })}
                ref={setRef}
                disabled={disabled}
              />
            </div>
            <span className="message--small message--error">
              {errors.average_booking_value &&
                errors.average_booking_value.message}
            </span>
          </div>
        </div>
      )}

      {schema?.appointment_preferences?.properties
        ?.can_reschedule_booking_online && (
        <div className="special-row">
          <p className="special-row__label">
            {schema?.appointment_preferences?.properties
              ?.can_reschedule_booking_online.description ||
              `Can guests reschedule an appointment online?`}
          </p>
          <div className="special-row__input">
            <ToggleSwitch
              checked={!!details.can_reschedule_booking_online}
              name="can_reschedule_booking_online"
              onChange={onOnlineRescheduleBooking}
              disabled={disabled}
            />
          </div>
        </div>
      )}

      {schema?.appointment_preferences?.properties
        ?.can_cancel_booking_online && (
        <div className="special-row">
          <p className="special-row__label">
            {schema?.appointment_preferences?.properties
              ?.can_cancel_booking_online.description ||
              `Can guests cancel an appointment online?`}
          </p>
          <div className="special-row__input">
            <ToggleSwitch
              checked={!!details.can_cancel_booking_online}
              name="can_cancel_booking_online"
              onChange={onOnlineCancelBooking}
              disabled={disabled}
            />
          </div>
        </div>
      )}

      {schema?.appointment_preferences?.properties.cancellation_duration && (
        <div className="bookings__row">
          <p className="bookings__row__label">
            {schema?.appointment_preferences?.properties.cancellation_duration
              ?.description || `Select the late cancellation window`}
          </p>
          <div className="bookings__row__input">
            <Select
              value={cancellationDuration.filter(
                (option) => option.value === details.cancellation_duration,
              )}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              options={cancellationDuration}
              styles={customStyles}
              onChange={onCancellationDurationChange}
              disabled={disabled}
            />
          </div>
        </div>
      )}
      {schema?.appointment_preferences?.properties
        .cancel_appt_within_duration && (
        <div className="special-row">
          <p className="special-row__label">
            {schema?.appointment_preferences?.properties
              .cancel_appt_within_duration?.description ||
              `Can TrueLark cancel appointments within your late cancellation window?`}
            {/* How close to the start of the appointment can TrueLark Cancel appointments */}
          </p>
          <div className="special-row__input">
            <ToggleSwitch
              checked={!!details.cancel_appt_within_duration}
              name="cancel_appt_within_duration"
              onChange={onCancelAppointmentDurationChange}
              disabled={disabled}
            />
            {/* <Select
            value={bookBefore.filter((option) => option.value === details.cancel_appt_within_24hrs)}
            getOptionLabel={option => option.label}
            getOptionValue={option => option.value}
            options={bookBefore}
            onChange={onCancelAppointment24Change}
            disabled={disabled}
          /> */}
          </div>
        </div>
      )}
      {schema?.appointment_preferences?.properties.cancellation_charges && (
        <div className="bookings__row">
          <p className="bookings__row__label">
            {schema?.appointment_preferences?.properties.cancellation_charges
              ?.description || `What are your cancellation charges?`}
          </p>
          <div className="bookings__row__input">
            <input
              type="text"
              placeholder="e.g. 50%, $25"
              name="cancellation_charges"
              value={details.cancellation_charges}
              onChange={onChange}
              className={classnames({
                'has-error': errors.cancellation_charges,
              })}
              ref={setRef}
              disabled={disabled}
            />
            <span className="message--small message--error">
              {errors.cancellation_charges &&
                errors.cancellation_charges.message}
            </span>
          </div>
        </div>
      )}
      {schema?.appointment_preferences?.properties.cancellation_policy_url && (
        <div className="bookings__row">
          <p className="bookings__row__label">
            {schema?.appointment_preferences?.properties.cancellation_policy_url
              ?.description || `What is your cancellation policy?`}
          </p>
          <div className="bookings__row__input">
            <TextareaCounter
              rows="3"
              name="cancellation_policy_url"
              value={details.cancellation_policy_url}
              onChange={onChange}
              maxLength={160}
              disabled={disabled}
            />
          </div>
        </div>
      )}
      {schema?.post_booking_instructions &&
        (bzsW !== 'SCIBLER' || (bzsW === 'SCIBLER' && domain === 'SALON')) && (
          <div className="chats__row">
            <p className="chats__row__label">
              {schema?.post_booking_instructions?.description ||
                `Are there any specific post-booking messages you would like TrueLark
          to share? If so, please specify here.`}
            </p>
            <div className="chats__row__input">
              <TextareaCounter
                rows="3"
                placeholder="Please arrive 5 minutes before your appointment if you are a new guest"
                name="post_booking_instructions"
                value={details.post_booking_instructions}
                onChange={onChange}
                maxLength={160}
                disabled={disabled}
              />
            </div>
          </div>
        )}
      {schema?.appointment_preferences?.properties.client_running_late && (
        <div className="bookings__row">
          <p className="bookings__row__label">
            {schema?.appointment_preferences?.properties.client_running_late
              ?.description ||
              `In case a guest informs us that they&apos;re running late, what
          would you like TrueLark to say?`}
          </p>
          <div className="bookings__row__input">
            <TextareaCounter
              rows="3"
              placeholder={
                'Customers are allowed to be upto 5 mins late for an appointment. If you are any later, your appointment may be cancelled and you will have to bear any cancellation costs.'
              }
              name="client_running_late"
              value={details.client_running_late}
              onChange={onChange}
              maxLength={160}
              disabled={disabled}
            />
          </div>
        </div>
      )}
      {schema?.appointment_preferences?.properties
        .can_share_pricing_with_clients && (
        <div className="special-row">
          <p className="special-row__label">
            {schema?.appointment_preferences?.properties
              .can_share_pricing_with_clients?.description ||
              `Can TrueLark share pricing information with guests?`}
          </p>
          <div className="special-row__input">
            <ToggleSwitch
              checked={!!details.can_share_pricing_with_clients}
              name="can_share_pricing_with_clients"
              onChange={onSharePricingChange}
              disabled={disabled}
            />
          </div>
        </div>
      )}
      {!!details.can_share_pricing_with_clients && schema?.pricing_info && (
        <div className="bookings__row">
          <p className="bookings__row__label">
            {schema?.pricing_info?.description ||
              `Where should we send them to?`}
            <sup>*</sup>
          </p>
          <div className="bookings__row__input">
            <TextareaCounter
              rows="3"
              placeholder={'Recommend Pricing Page or Online Booking link.'}
              name="pricing_info"
              value={details.pricing_info}
              className={classnames({ 'has-error': errors.pricing_info })}
              onChange={onChange}
              maxLength={160}
              ref={setRef}
              disabled={disabled}
            />
          </div>
          <span className="message--small message--error">
            {errors.pricing_info && errors.pricing_info.message}
          </span>
        </div>
      )}
      {schema?.appointment_preferences?.properties.appointments_walk_in && (
        <div className="special-row">
          <p className="special-row__label">
            {schema?.appointment_preferences?.properties.appointments_walk_in
              ?.description || `Do you take walk-in appointments?`}
          </p>
          <div className="special-row__input">
            <ToggleSwitch
              checked={!!details.appointments_walk_in}
              name="appointments_walk_in"
              onChange={onWalkInAppointmentsChange}
              disabled={disabled}
            />
          </div>
        </div>
      )}

      {!!details.appointments_walk_in &&
        schema?.appointment_preferences?.properties
          .is_walk_in_on_availability && (
          <div className="special-row">
            <p className="special-row__label">
              {schema?.appointment_preferences?.properties
                .is_walk_in_on_availability?.description ||
                `Are walk-ins based on availability?`}
            </p>
            <div className="special-row__input">
              <ToggleSwitch
                checked={!!details.is_walk_in_on_availability}
                name="is_walk_in_on_availability"
                onChange={isWalkInBasedOnAvailablity}
                disabled={disabled}
              />
            </div>
          </div>
        )}
    </div>
  );
}

Bookings.defaultProps = {
  onChange: () => {},
  setRef: () => {},
  details: {},
  errors: {},
  disabled: false,
};

Bookings.propTypes = {
  onChange: PropTypes.func,
  setRef: PropTypes.func,
  details: PropTypes.shape(),
  errors: PropTypes.shape(),
  disabled: PropTypes.bool,
};
